import { ExternalLink } from 'lucide-react';

/**
 * Inline preview топ-5 sub-processors прямо в Privacy Policy §5.
 * Stripe-pattern trust signal — показываем таблицей, не только ссылкой.
 *
 * Источник правды — `subprocessors-ru-v1.0.md` (полный список) и
 * `/legal/subprocessors` page. Здесь — компактный мост.
 *
 * При обновлении списка sub-processors — обновить ОБА места (md + здесь).
 */

interface SubProc {
  name: string;
  category: string;
  region: string;
  purpose: string;
  status: 'active' | 'planned';
}

const TOP_PROCESSORS: SubProc[] = [
  {
    name: 'Cloudflare Pages',
    category: 'Hosting',
    region: 'Global CDN',
    purpose: 'Лендинг agentceo.ru',
    status: 'active',
  },
  {
    name: 'Time4VPS',
    category: 'Hosting',
    region: 'Литва (ЕС)',
    purpose: 'Auth backend (UAT/Stage)',
    status: 'active',
  },
  {
    name: 'Anthropic',
    category: 'AI provider',
    region: 'США',
    purpose: 'CEO + agents inference',
    status: 'planned',
  },
  {
    name: 'Postal (self-hosted)',
    category: 'Email',
    region: 'РФ',
    purpose: 'Auth emails',
    status: 'planned',
  },
  {
    name: 'Yandex.Metrika',
    category: 'Analytics',
    region: 'РФ',
    purpose: 'Анонимная статистика (после consent)',
    status: 'planned',
  },
];

const TOTAL_COUNT = 9;

export function SubprocessorsPreview() {
  return (
    <div className="my-8 rounded-lg border border-border bg-surface-canvas overflow-hidden">
      <div className="overflow-x-auto">
        <table className="min-w-full text-sm tabular-nums">
          <thead>
            <tr className="bg-surface-subtle">
              <th className="px-3 py-2 text-left font-medium text-text-secondary">Provider</th>
              <th className="px-3 py-2 text-left font-medium text-text-secondary">Категория</th>
              <th className="px-3 py-2 text-left font-medium text-text-secondary hidden md:table-cell">Регион</th>
              <th className="px-3 py-2 text-left font-medium text-text-secondary hidden lg:table-cell">Цель</th>
              <th className="px-3 py-2 text-left font-medium text-text-secondary">Статус</th>
            </tr>
          </thead>
          <tbody>
            {TOP_PROCESSORS.map((p) => (
              <tr key={p.name} className="border-t border-border">
                <td className="px-3 py-2 font-medium text-text-primary">{p.name}</td>
                <td className="px-3 py-2 text-text-secondary">{p.category}</td>
                <td className="px-3 py-2 text-text-secondary hidden md:table-cell">{p.region}</td>
                <td className="px-3 py-2 text-text-secondary hidden lg:table-cell">{p.purpose}</td>
                <td className="px-3 py-2">
                  <span
                    className={
                      p.status === 'active'
                        ? 'inline-flex items-center rounded-full bg-status-success-bg px-2 py-0.5 text-xs font-medium text-status-success-text'
                        : 'inline-flex items-center rounded-full bg-surface-subtle px-2 py-0.5 text-xs font-medium text-text-secondary'
                    }
                  >
                    {p.status === 'active' ? 'Активен' : 'Планируется'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="border-t border-border bg-surface-subtle px-3 py-2 text-sm">
        <a
          href="/legal/subprocessors"
          className="inline-flex items-center gap-1.5 text-text-link hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus/40 rounded"
        >
          Полный список ({TOTAL_COUNT}) и условия передачи
          <ExternalLink className="h-3.5 w-3.5" aria-hidden />
        </a>
      </div>
    </div>
  );
}
